export const mainNavigation = [
    {
        "name": "Portfolio",
        "path": "/portfolio",
        "children": []
    },
    {
        "name": "Über uns",
        "path": "/ueber-uns",
        "children": []
    },
    {
        "name": "Kontakt",
        "path": "/kontakt",
        "children": []
    },
    {
        "name": "Downloads",
        "path": "/downloads",
        "children": []
    }
]

export const footerNavigation = [
    {
        "name": "Murteldt Additive Solutions",
        "path": "/",
        "children": [
            {
                "name": "Portfolio",
                "path": "/portfolio"
            },
            {
                "name": "Kontakt",
                "path": "/kontakt"
            }
        ]
    },
    {
        "name": "Rechtliches",
        "path": "",
        "children": [
            {
                "name": "Datenschutz",
                "path": "/Datenschutz"
            },
            {
                "name": "Impressum",
                "path": "/Impressum"
            },
            {
                "name": "AGB",
                "path": "/AGB"
            },
            {
                "name": "AEB",
                "path": "/AEB"
            }
        ]
    },
]

export const contentNavigation = [
    {
        "name": "Beratung",
        "path": "/beratung",
        "children": [
            {
                "name": "Produktionsverfahren",
                "path": "produtionsverfahren"
            },
            {
                "name": "Datenformate",
                "path": "/datenformate"
            }
        ]
    },
    {
        "name": "Konstruktion",
        "path": "/Konstruktion",
        "children": [
            {
                "name": "Datenentwicklung (CAD)",
                "path": "/datenentwicklung"
            },
            {
                "name": "Datenscan",
                "path": "/datenscan"
            }
        ]
    },
    {
        "name": "Produktion",
        "path": "/produktion",
        "children": [
            {
                "name": "Produktbeispiele",
                "path": "/produktbeispiele"
            },
            {
                "name": "Materialien",
                "path": "/Materialien"
            }
        ]
    }
];

export const cmsPages = [
    {
        name: "ueber-uns",
        content: [
            {
                type: "img",
                data: {
                    src: "https://via.placeholder.com/720x400/DEF3EE/999999?text=Über-uns"
                }
            },
            {
                type: "text",
                data: {
                    text: "Lorem Ipsum Dolor Sit Amet"
                }
            }, {
                type: "richtext",
                data: {
                    html: "<h1>In dictum, nunc pellentesque rutrum sollicitudin.</h1><p>Sed suscipit tempus massa nec elementum. Ut a varius ligula. Proin ut venenatis elit. Vestibulum eget tortor in risus ultrices mattis. Duis eget risus ornare, malesuada lectus efficitur, malesuada lacus.</p>"
                }
            }
        ]
    },
    {
        name: "portfolio",
        content: [
            {
                type: "richtext",
                data: {
                    html: "<h2 style='text-align: center;'>Intro Text</h2><p>Proin aliquam nibh leo, sit amet hendrerit est porta id. Cras vel nisi ut ante pretium posuere a sit amet metus. Vestibulum sollicitudin velit et bibendum congue.</p>"
                }
            },
            {
                type: "img",
                data: {
                    src: "https://via.placeholder.com/720x400/BDBDBD/999999?Text=Portfolio"
                }
            },
            {
                type: "text",
                data: {
                    text: "Tempor semper lectus. Suspendisse egestas, est ac tincidunt placerat, elit lacus suscipit magna, id dignissim magna ligula laoreet ipsum. Quisque turpis ligula, iaculis in tincidunt eu, convallis sit amet sem. Vivamus ut dui eleifend, euismod dui et, tincidunt erat."
                }
            }, {
                type: "richtext",
                data: {
                    html: "<h1>Cras in justo non ligula euismod fermentum. Maecenas tincidunt justo et volutpat volutpat. Aenean imperdiet orci vel dui posuere tempus. Phasellus sit amet turpis dignissim, malesuada nisl et, viverra ante. Duis vestibulum, risus in vulputate porta, eros orci fermentum quam, sit amet blandit tellus urna id mauris. Nam rhoncus sit amet est eu egestas. Vivamus rhoncus justo at risus molestie, id consequat purus mollis.</h1> Nunc consequat neque eleifend diam eleifend viverra. Donec sollicitudin varius diam a fringilla. Nunc risus nibh, pellentesque a neque quis.</p>"
                }
            }
        ]
    }
]

export const availableMaterials = [
    [
        1,
        "Plastic Sintering",
        "Polyamide",
        "strong flexible plastic",
        "White",
        "RGB",
        "#FFFFFF",
        4,
        6.5,
        0.19,
        1,
        0,
        1200,
        0.7,
        0.63,
        0.37,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh_gray.jpg",
        0.4,
        0.15,
        0.8,
        40,
        35,
        50,
        6,
        1,
        "SLS_PA_wh"],
    [2,
        "Plastic Sintering",
        "Polyamide",
        "strong flexible plastic",
        "Red",
        "RGB",
        "#95030E",
        4,
        8,
        0.21,
        2,
        0,
        1200,
        0.7,
        0.63,
        0.37,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh_gray.jpg",
        0.4,
        0.15,
        0.8,
        40,
        35,
        50,
        6,
        1,
        "SLS_PA_wh"],
    [3,
        "Plastic Sintering",
        "Polyamide",
        "strong flexible plastic",
        "Black",
        "RGB",
        "#1E1E1E",
        4,
        8,
        0.21,
        2,
        0,
        1200,
        0.7,
        0.63,
        0.37,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_bl.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_bl_gray.jpg",
        0.4,
        0.15,
        0.8,
        40,
        35,
        50,
        6,
        1,
        "SLS_PA_bl"],
    [4,
        "Plastic Sintering",
        "Polyamide",
        "strong flexible plastic",
        "Blue",
        "RGB",
        "#3072B5",
        4,
        8,
        0.21,
        2,
        0,
        1200,
        0.7,
        0.63,
        0.37,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh_gray.jpg",
        0.4,
        0.15,
        0.8,
        40,
        35,
        50,
        6,
        1,
        "SLS_PA_wh"],
    [5,
        "Plastic Sintering",
        "Polyamide",
        "strong flexible plastic",
        "Yellow",
        "RGB",
        "#FFCC19",
        4,
        8,
        0.21,
        2,
        0,
        1200,
        0.7,
        0.63,
        0.37,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh_gray.jpg",
        0.4,
        0.15,
        0.8,
        40,
        35,
        50,
        6,
        1,
        "SLS_PA_wh"],
    [6,
        "Resin-bonded Plastic",
        "Grained Acrylic",
        "fine grainy plastic",
        "Yellow",
        "RGB",
        "#FFD427",
        0,
        26.9,
        0.7883,
        1.3704,
        0,
        317,
        0.73,
        1,
        0,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg",
        0.1,
        0.15,
        1.5,
        50,
        40,
        30,
        19,
        2,
        "RBP_PMMA_ye"],
    [7,
        "Resin-bonded Plastic",
        "Grained Acrylic",
        "fine grainy plastic",
        "Gray",
        "RGB",
        "#797979",
        0,
        26.9,
        0.7883,
        1.3704,
        0,
        317,
        0.73,
        1,
        0,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_gr.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_gr_gray.jpg",
        0.1,
        0.15,
        1.5,
        50,
        40,
        30,
        19,
        2,
        "RBP_PMMA_gr"],
    [
        8,
        "Resin-bonded Plastic",
        "Grained Acrylic",
        "fine grainy plastic",
        "Black",
        "RGB",
        "#1E1E1E",
        0,
        26.9,
        0.7883,
        1.3704,
        0,
        317,
        0.73,
        1,
        0,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_bl.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_bl_gray.jpg",
        0.1,
        0.15,
        1.5,
        50,
        40,
        30,
        19,
        2,
        "RBP_PMMA_bl"],
    [
        9,
        "Extruded Plastic",
        "Thermoplastic ABS",
        "strong shiny plastic",
        "Ivory",
        "RGB",
        "#FFECC3",
        2.33,
        7.8,
        0.742,
        0.742,
        0,
        0,
        1,
        0.112,
        0.888,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_FDM_ABS_iv.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_FDM_ABS_iv_gray.jpg",
        0.4,
        0.25,
        1,
        20,
        20,
        15,
        10,
        3,
        "FDM_ABS_iv"],
    [
        10,
        "Resin-bonded Plaster",
        "Plaster",
        "artificial sandstone",
        "Full Color",
        "FC",
        "#FFFFFF",
        6.04,
        11.5,
        1.386,
        1.2075,
        0,
        40,
        1,
        0.05,
        0.95,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_Z_PL_fc.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_Z_PL_fc_gray.jpg",
        0.1,
        0.1,
        2,
        25,
        38,
        20,
        24,
        4,
        "Z_PL_fc"],
    [
        11,
        "Resin-bonded Plaster",
        "Plaster",
        "artificial sandstone",
        "White",
        "RGB",
        "#FFFFFF",
        4.83,
        9.5,
        1.092,
        0.966,
        0,
        40,
        1,
        0.05,
        0.95,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_Z_PL_fc.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_Z_PL_fc_gray.jpg",
        0.1,
        0.1,
        2,
        25,
        38,
        20,
        24,
        4,
        "Z_PL_fc"],
    [
        12,
        "Rubber Sintering",
        "Thermo-PU",
        "rubber-like plastic",
        "Ivory",
        "RGB",
        "#D0D4CF",
        0,
        8.1,
        2.4675,
        2.4675,
        0,
        0,
        1,
        0.008,
        0.992,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_TPU_iv.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_TPU_iv_gray.jpg",
        0.75,
        0.25,
        1,
        19,
        23,
        30,
        14,
        5,
        "SLS_TPU_iv"],
    [
        13,
        "Rubber Sintering",
        "Thermo-PU",
        "rubber-like plastic",
        "Black",
        "RGB",
        "#1E1E1E",
        0.99,
        9.1,
        2.5662,
        2.5662,
        0,
        0,
        1,
        0.0154,
        0.9846,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_TPU_iv.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_TPU_iv_gray.jpg",
        0.75,
        0.25,
        1,
        19,
        23,
        30,
        14,
        5,
        "SLS_TPU_iv"],
    [
        14,
        "Alumide Sintering",
        "Alumide",
        "aluminium-plastic-mix",
        "Mat Metallic",
        "ALUMIDE",
        "#ADB4B4",
        5,
        8.1,
        0.21,
        2.01,
        0,
        1200,
        0.7,
        0.63,
        0.37,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_ALide.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_ALide_gray.jpg",
        0.4,
        0.15,
        1,
        19,
        23,
        30,
        14,
        6,
        "SLS_ALide"],
    [
        15,
        "Resin Printing",
        "Resin",
        "transparent plastic",
        "Transparent",
        "CLEAR",
        "#C7CAC6",
        68.2,
        77.5,
        4.0205,
        4.0205,
        0.403,
        0,
        0.805,
        0.04,
        0.96,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLA_trans.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLA_trans_gray.jpg",
        0.2,
        0.1,
        1.25,
        20,
        20,
        20,
        19,
        7,
        "SLA_trans"],
    [
        16,
        "Silver Casting",
        "Silver",
        "casted silver",
        "Silver",
        "SILVER",
        "#F3F2Ef",
        28.9,
        28.9,
        36.225,
        48.825,
        0,
        0.25,
        1,
        0,
        1,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_WXCST_Silv.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_WXCST_Silv_gray.jpg",
        0.15,
        0.15,
        1,
        8,
        8,
        10,
        27,
        8,
        "WXCST_Silv"],
    [
        17,
        "Resin-bonded Plastic",
        "Grained Acrylic",
        "fine grainy plastic",
        "Red",
        "RGB",
        "#95030E",
        0,
        26.9,
        0.7883,
        1.3704,
        0,
        317,
        0.73,
        1,
        0,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg",
        0.1,
        0.15,
        1.5,
        50,
        40,
        30,
        19,
        2,
        "RBP_PMMA_ye"],
    [
        18,
        "Resin-bonded Plastic",
        "Grained Acrylic",
        "fine grainy plastic",
        "Metallic Sand",
        "RGB",
        "#ADB4B4",
        0,
        26.9,
        0.7883,
        1.3704,
        0,
        317,
        0.73,
        1,
        0,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg",
        0.1,
        0.15,
        1.5,
        50,
        40,
        30,
        19,
        2,
        "RBP_PMMA_ye"],
    [
        19,
        "Resin-bonded Plastic",
        "Grained Acrylic",
        "fine grainy plastic",
        "Ivory",
        "RGB",
        "#FFECC3",
        0,
        26.9,
        0.7883,
        1.3704,
        0,
        317,
        0.73,
        1,
        0,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg",
        0.1,
        0.15,
        1.5,
        50,
        40,
        30,
        19,
        2,
        "RBP_PMMA_ye"],
    [
        21,
        "Plastic Sintering",
        "Polyamide",
        "strong flexible plastic",
        "Lime Green",
        "RGB",
        "#AEB544",
        4,
        8,
        0.21,
        2,
        0,
        1200,
        0.7,
        0.63,
        0.37,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh_gray.jpg",
        0.4,
        0.15,
        0.8,
        40,
        35,
        50,
        6,
        1,
        "SLS_PA_wh"],
    [
        22,
        "Plastic Sintering",
        "Polyamide",
        "strong flexible plastic",
        "Violet",
        "RGB",
        "#7133AC",
        4,
        8,
        0.21,
        2,
        0,
        1200,
        0.7,
        0.63,
        0.37,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh_gray.jpg",
        0.4,
        0.15,
        0.8,
        40,
        35,
        50,
        6,
        1,
        "SLS_PA_wh"],
    [
        23,
        "Plastic Sintering",
        "Polyamide",
        "strong flexible plastic",
        "Orange",
        "RGB",
        "#EB5D26",
        4,
        8,
        0.21,
        2,
        0,
        1200,
        0.7,
        0.63,
        0.37,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_SLS_PA_wh_gray.jpg",
        0.4,
        0.15,
        0.8,
        40,
        35,
        50,
        6,
        1,
        "SLS_PA_wh"],
    [
        24,
        "Resin-bonded Plastic",
        "Grained Acrylic",
        "fine grainy plastic",
        "Orange",
        "RGB",
        "#B83224",
        0,
        26.9,
        0.7883,
        1.3704,
        0,
        317,
        0.73,
        1,
        0,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg",
        0.1,
        0.15,
        1.5,
        50,
        40,
        30,
        19,
        2,
        "RBP_PMMA_ye"],
    [
        25,
        "Resin-bonded Plastic",
        "Grained Acrylic",
        "fine grainy plastic",
        "Brown",
        "RGB",
        "#461E23",
        0,
        26.9,
        0.7883,
        1.3704,
        0,
        317,
        0.73,
        1,
        0,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg",
        0.1,
        0.15,
        1.5,
        50,
        40,
        30,
        19,
        2,
        "RBP_PMMA_ye"],
    [
        26,
        "Resin-bonded Plastic",
        "Grained Acrylic",
        "fine grainy plastic",
        "Green",
        "RGB",
        "#2B5033",
        0,
        26.9,
        0.7883,
        1.3704,
        0,
        317,
        0.73,
        1,
        0,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg",
        0.1,
        0.15,
        1.5,
        50,
        40,
        30,
        19,
        2,
        "RBP_PMMA_ye"],
    [
        27,
        "Resin-bonded Plastic",
        "Grained Acrylic",
        "fine grainy plastic",
        "Blue",
        "RGB",
        "#25425E",
        0,
        26.9,
        0.7883,
        1.3704,
        0,
        317,
        0.73,
        1,
        0,
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye.jpg",
        "https://3d-print.jomatik.de/grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg",
        0.1,
        0.15,
        1.5,
        50,
        40,
        30,
        19,
        2,
        "RBP_PMMA_ye"],
]

export const analyzedDummyObject = {

    frontPictures: {
        XM_0: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_XM_0.png",
        XM_90: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_XM_90.png",
        XM_180: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_XM_180.png",
        XM_270: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_XM_270.png",
        XP_0: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_XP_0.png",
        XP_90: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_XP_90.png",
        XP_180: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_XP_180.png",
        XP_270: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_XP_270.png",
        YM_0: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_YM_0.png",
        YM_90: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_YM_90.png",
        YM_180: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_YM_180.png",
        YM_270: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_YM_270.png",
        YP_0: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_YP_0.png",
        YP_90: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_YP_90.png",
        YP_180: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_YP_180.png",
        YP_270: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_YP_270.png",
        ZM_0: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_ZM_0.png",
        ZM_90: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_ZM_90.png",
        ZM_180: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_ZM_180.png",
        ZM_270: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_ZM_270.png",
        ZP_0: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_ZP_0.png",
        ZP_90: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_ZP_90.png",
        ZP_180: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_ZP_180.png",
        ZP_270: "tmp/printorder/prev_images/imageUpload_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega_ZP_270.png"
    },
    convertedFileUrl: "tmp/printorder/prev_images/objectTmp_391f4e9dd40979dc6a6ee8da6859478eac480f04Suffixzthkega.3mf",
    VXYZ: {
        DimX: 290,
        DimY: 290,
        DimZ: 19.9998,
        Surface: 47618.3,
        Vext: 925015.4241732559,
        Vint: 61548.3,
    }
};

export const userAccountDetails = {
    user_name: "kevink",
    first_name: "Kevin",
    last_name: "Kössl",
    e_mail: "kk@7pkonzepte.de",
    phone: "017621978403",
    ship_first_name: "Kevin",
    ship_company_dept: "7P IT-Abteilung",
    ship_street: "Rheinische Straße",
    ship_house_number: "171",
    ship_zip_code: "44147",
    ship_city: "Dortmund",
    ship_country: "Germany",
    ship_other_country: false,
    bill_as_ship: false,
    bill_first_name: "Max Muster Mann",
    bill_company_dept: "7P Marketing Abteilung",
    bill_street: "Rheinische Straße",
    bill_house_number: "171",
    bill_zip_code: "44147",
    bill_city: "Dortmund",
    payment_method: "Paypal"
}

export const ContactDetails = {
    first_name: "Kevin",
    last_name: "Kössl",
    e_mail: "kk@7pkonzepte.de",
    phone: "017621978403",
    subject: "Betreff",
    message: "hallo, was geht?"
}

export const testMailForm = {
    mail: "lb@7pKonzepte.de",
    message:"hallo",
    confirmation:true
}

export const dummyCartItem2 = {
    "name": "Cube_3d_printing_sample",
    "file": "[object File]",
    "quantity": 5,
    "dimensions": {"DimX": 20, "DimY": 20, "DimZ": 20, "Surface": 2400, "Vint": 8000, "Vext": 8000},
    "unit": "mm",
    "scale": "0.1",
    "material": {
        "name": "Grained Acrylic",
        "desc": "fine grainy plastic",
        "img": "grafix/material-previews/spm_RBP_PMMA_gr.jpg",
        "selectedColorIndex": 1,
        "availableColors": [[6, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Yellow", "RGB", "#FFD427", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [7, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Gray", "RGB", "#797979", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_gr.jpg", "grafix/material-previews/spm_RBP_PMMA_gr_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_gr"], [8, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Black", "RGB", "#1E1E1E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_bl.jpg", "grafix/material-previews/spm_RBP_PMMA_bl_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_bl"], [17, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Red", "RGB", "#95030E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [18, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Metallic Sand", "RGB", "#ADB4B4", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [19, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Ivory", "RGB", "#FFECC3", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [24, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Orange", "RGB", "#B83224", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [25, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Brown", "RGB", "#461E23", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [26, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Green", "RGB", "#2B5033", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [27, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Blue", "RGB", "#25425E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"]]
    },
    "color": {
        "name": "Grained Acrylic",
        "desc": "fine grainy plastic",
        "img": "grafix/material-previews/spm_RBP_PMMA_gr.jpg",
        "selectedColorIndex": 1,
        "availableColors": [[6, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Yellow", "RGB", "#FFD427", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [7, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Gray", "RGB", "#797979", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_gr.jpg", "grafix/material-previews/spm_RBP_PMMA_gr_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_gr"], [8, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Black", "RGB", "#1E1E1E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_bl.jpg", "grafix/material-previews/spm_RBP_PMMA_bl_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_bl"], [17, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Red", "RGB", "#95030E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [18, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Metallic Sand", "RGB", "#ADB4B4", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [19, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Ivory", "RGB", "#FFECC3", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [24, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Orange", "RGB", "#B83224", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [25, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Brown", "RGB", "#461E23", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [26, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Green", "RGB", "#2B5033", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [27, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Blue", "RGB", "#25425E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"]]
    },
    "convertedFileUrl": "https://3d-print.jomatik.de/tmp/printorder/prev_images/objectTmp_76873cdb656ccac252d3d148cc6adf52a445b0d7Suffixorrkyarzk.3mf"
};

export const dummyCartItem1 = {
    "name": "CartItem1",
    "file": "[object File]",
    "quantity": 12,
    "dimensions": {"DimX": 20, "DimY": 20, "DimZ": 20, "Surface": 2400, "Vint": 8000, "Vext": 8000},
    "unit": "mm",
    "scale": "0.1",
    "material": {
        "name": "Grained Acrylic",
        "desc": "fine grainy plastic",
        "img": "grafix/material-previews/spm_RBP_PMMA_gr.jpg",
        "selectedColorIndex": 1,
        "availableColors": [[6, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Yellow", "RGB", "#FFD427", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [7, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Gray", "RGB", "#797979", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_gr.jpg", "grafix/material-previews/spm_RBP_PMMA_gr_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_gr"], [8, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Black", "RGB", "#1E1E1E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_bl.jpg", "grafix/material-previews/spm_RBP_PMMA_bl_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_bl"], [17, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Red", "RGB", "#95030E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [18, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Metallic Sand", "RGB", "#ADB4B4", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [19, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Ivory", "RGB", "#FFECC3", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [24, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Orange", "RGB", "#B83224", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [25, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Brown", "RGB", "#461E23", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [26, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Green", "RGB", "#2B5033", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [27, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Blue", "RGB", "#25425E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"]]
    },
    "color": {
        "name": "Grained Acrylic",
        "desc": "fine grainy plastic",
        "img": "grafix/material-previews/spm_RBP_PMMA_gr.jpg",
        "selectedColorIndex": 1,
        "availableColors": [[6, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Yellow", "RGB", "#FFD427", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [7, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Gray", "RGB", "#797979", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_gr.jpg", "grafix/material-previews/spm_RBP_PMMA_gr_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_gr"], [8, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Black", "RGB", "#1E1E1E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_bl.jpg", "grafix/material-previews/spm_RBP_PMMA_bl_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_bl"], [17, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Red", "RGB", "#95030E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [18, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Metallic Sand", "RGB", "#ADB4B4", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [19, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Ivory", "RGB", "#FFECC3", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [24, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Orange", "RGB", "#B83224", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [25, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Brown", "RGB", "#461E23", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [26, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Green", "RGB", "#2B5033", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"], [27, "Resin-bonded Plastic", "Grained Acrylic", "fine grainy plastic", "Blue", "RGB", "#25425E", 0, 26.9, 0.7883, 1.3704, 0, 317, 0.73, 1, 0, "grafix/material-previews/spm_RBP_PMMA_ye.jpg", "grafix/material-previews/spm_RBP_PMMA_ye_gray.jpg", 0.1, 0.15, 1.5, 50, 40, 30, 19, "2", "RBP_PMMA_ye"]]
    },
    "convertedFileUrl": "https://3d-print.jomatik.de/tmp/printorder/prev_images/objectTmp_76873cdb656ccac252d3d148cc6adf52a445b0d7Suffixorrkyarzk.3mf"
};

export const profileOrdersList = [
    {
        "orderID": "36229",
        "status": "payment pending",
        "date": "2020-08-13 13:48:26",
        "priceSum": "119.05",
        "shipCost": "9.90"
    },
    {
        "orderID": "36229",
        "status": "payment pending",
        "date": "2020-08-13 13:48:26",
        "priceSum": "119.05",
        "shipCost": "9.90"
    },
    {
        "orderID": "36229",
        "status": "payment pending",
        "date": "2020-08-13 13:48:26",
        "priceSum": "119.05",
        "shipCost": "9.90"
    },
    {
        "orderID": "36229",
        "status": "payment pending",
        "date": "2020-08-13 13:48:26",
        "priceSum": "119.05",
        "shipCost": "9.90"
    }
];
export const profileOrderItem = {
    "orderID": "36229",
    "date": "2020-08-13 13:48:26",
    "status": "payment pending",
    "client": "trinckle",
    "dueDate": null,
    "prodTime": "6",
    "shipTime": "2",
    "user": {
        "firstName": "Testbenutzer",
        "lastName": "Test",
        "mail": "ms@7pkonzepte.de",
        "phone": ""
    },
    "payment": {
        "priceSum": "119.05",
        "shipCost": "9.90",
        "priceBrutto": "128.95",
        "method": "Banküberweisung"
    },
    "shipping": {
        "firstName": "Testbenutzer",
        "lastName": "asdasd",
        "address": "Herr",
        "street": "Teststraße 1, 123, 123",
        "houseNumber": "123",
        "postalCode": "44137",
        "city": "1",
        "country": "Deutschland",
        "countryCode": "DE"
    },
    "billing": {
        "firstName": "Testbenutzer",
        "lastName": "asdasd",
        "address": "Herr",
        "street": "Teststraße 1, 123, 123",
        "houseNumber": "123",
        "postalCode": "44137",
        "city": "1",
        "country": "Deutschland"
    },
    "basket": [
        {
            "id": "69049",
            "orderId": "36229",
            "objectId": "0",
            "orderDesc": "test",
            "scale": "1",
            "intVolSingle": "61.5483",
            "dimX": "29",
            "dimY": "1.99998",
            "dimZ": "29",
            "surface": "476.183",
            "spmId": "1",
            "spmName": "Kunststoff-Sintern",
            "spmMethodSys": "SLS",
            "spmMatSys": "PA",
            "spmMat": "Polyamid",
            "spmColNameSys": "Weiß",
            "spmColName": "Weiß",
            "spmPriceP0": "4",
            "spmPricePmin": "6.5",
            "spmPriceA": "0.19",
            "spmPriceB": "1",
            "spmPriceC": "0",
            "spmPriceV1": "1200",
            "spmPriceQ": "0.7",
            "spmPriceAlpha": "0.63",
            "spmPriceBeta": "0.37",
            "spmProdTime": "6",
            "spmResXY": "0.40",
            "spmResZ": "0.15",
            "spmMaxDimX": "40.00",
            "spmMaxDimY": "35.00",
            "spmMaxDimZ": "50.00",
            "quantity": "1",
            "extVolSingle": "925.015424",
            "priceSingle": "119.05",
            "priceSum": "119.05",
            "priceNetto": "102.64",
            "priceBrutto": "119.05",
            "designPriceSingle": "0.00",
            "designPriceSum": "0.00",
            "shareDesigner": "0.00",
            "paymentDesigner": null,
            "designerId": "0",
            "designerFracTrinckle": "0",
            "designerTakesVAT": null,
            "designerTaxNumber": null,
            "designerPaid": "0",
            "statusId": "2",
            "comment": "",
            "repaired": "0",
            "spmMinFeatSize": "0.8",
            "spmMaxNParts": "1",
            "critX": "1.745",
            "extId_supplier": null,
            "cepOrderItemId": null,
            "campaignPartner": "",
            "imageUrl": "verwaltung_grafix/printorder/imageOrderItem_69049.png"
        }
    ]
};
